import { getBaseDomain } from 'js/utils/url.util';
import { getCookie, setCookie } from 'js/utils/cookie.util';

export const COOKIE_NAME = 'banner_domainclick';
export const COOKIE_PATH = '/';
export const COOKIE_EXPIRES = 30;
export const COOKIE_PARTS_KEYS = [
    'advertiser',
    'bannerid',
    'profileid',
    'refererurl',
    'creferer'
];

/**
 * Get an object with data from affiliate cookie
 * @function
 * @param [cookieName] {String} If unset, banner_domainclick cookie is used.
 * @returns {Object} {advertiser: String, bannerid: String, profileid: String, refererurl: String, creferer: String} | {}
 * @example getAffiliateData() -> banner_domainclick='advertiser,bannerid,profileid,refererurl,creferer'
 */
export const getAffiliateData = (cookieName = COOKIE_NAME) => {
    const result = {};
    const cookie = getCookie(cookieName);

    if (!cookie) {
        return result;
    }

    const cookieParts = cookie.split(',');

    if (cookieParts.length === 1) {
        result.advertiser = cookieParts[0];
    }

    if (cookieParts.length === COOKIE_PARTS_KEYS.length) {
        for (const cookiePartKey of COOKIE_PARTS_KEYS) {
            result[cookiePartKey] = cookieParts.shift();
        }
    }

    return result;
};

/**
 * Set an affiliate cookie from object
 * @function
 * @param [params] {advertiser: String, bannerid: String, profileid: String, refererurl: String, creferer: String} | {}
 * @param [cookieName] {String} If unset, banner_domainclick cookie is used.
 * @example setAffiliateCookie({ advertiser: 'advertiser', bannerid: 'bannerid', profileid: 'profileid', refererurl: 'refererur' })
 */
export const setAffiliateCookie = (params, cookieName = COOKIE_NAME) => {
    const cookieParts = [];

    if (Object.keys(params).length === 1 && Boolean(params.advertiser)) {
        cookieParts.push(params.advertiser);
    } else {
        for (const cookiePartKey of COOKIE_PARTS_KEYS) {
            cookieParts.push(params[cookiePartKey] ?? '');
        }
    }

    if (cookieParts.filter(Boolean).length > 0) {
        const cookie = cookieParts.join(',');
        const encodedCookie = cookie.replace(/;/g, encodeURIComponent(';'));

        setCookie(cookieName, encodedCookie, {
            domain: getBaseDomain(),
            path: COOKIE_PATH,
            expires: COOKIE_EXPIRES
        });
    }
};
